import LawBanner from './container'
export { LawBanner }
export default LawBanner